// extracted by mini-css-extract-plugin
export default {"rating":"sB-z","numberOfStars":"tB-z","count":"uB-z","barGraphSpacing":"vB-z","barGraph":"wB-z"};